import { render, staticRenderFns } from "./BasketSectionHeader.vue?vue&type=template&id=35fd3de0&scoped=true&"
import script from "./BasketSectionHeader.vue?vue&type=script&lang=ts&"
export * from "./BasketSectionHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BasketSectionHeader.vue?vue&type=style&index=0&id=35fd3de0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fd3de0",
  null
  
)

export default component.exports